const showErrorModalEvent = 'showErrorModal'
const showLoginModalEvent = 'showLoginModal'
const showMessageModalEvent = 'showMessageModal'

const showErrorModal = (context, error) => {
  if (!error || !error.status) {
    context.$emit(showErrorModalEvent, '予期せぬエラーが発生しました。')
  } else if (error.status === 400 || error.status >= 402) {
    context.$emit(showErrorModalEvent, error.body.message)
  }
}

const showLoginModal = (context, caption) => {
  context.$emit(showLoginModalEvent, caption)
}

const showMessageModal = (context, message) => {
  context.$emit(showMessageModalEvent, message)
}

export default {
  showErrorModal,
  showLoginModal,
  showMessageModal
}



// WEBPACK FOOTER //
// ./src/util/modal.js